<template>
    <modal :show.sync="visible"  modalClasses="by-country-popup">
        <div class="row">
            <div class="col-12">
                <table class="table">
                    <thead>
                        <th>Country</th>
                        <th>Region</th>
                        <th v-for="(label, key) in data.labels[dataKey]" :key="key" >{{ $t(label) }}</th>
                    </thead>
                    <tbody>
                        <tr v-for="(country, key) in data.data" :key="key">
                            <td>{{ country.countryName }}</td>
                            <td>{{ country.region }}</td>
                            <td v-for="(count, key) in country[dataKey]" :key="key" class="text-center">
                                {{ count }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
            </div>
            <div class="col-4 text-right">
                <base-button type="danger" @click.native="closeModal">Close</base-button>
            </div>
        </div>
    </modal>
</template>
<script>

import {Modal} from 'src/components';

export default
{
    name: "popup-by-country",
    components:
    {
        Modal,
    },
    props:
    {
        visible: Boolean,
        data: Object,
        dataKey: String,
        grantId: Number
    },
    data()
    {
        return {
        };
    },
    computed:
    {
    },
    mounted()
    {
    },
    methods:
    {
        closeModal()
        {
            this.$emit('update:visible', false);
            this.$emit('close');
        },
    }
};
</script>
<style lang="scss">
    .by-country-popup
    {
        max-width: 90%;
        // max-width: 1265px;
        max-height: 90%;
        // height: 100%;
        color: #a7a7a7 !important;
        overflow: hidden;
        transform: none !important;

        .modal-content
        {
            height: 100%;
            max-height: 90vh;
            overflow: hidden;
        }

        .modal-body
        {
            height: 100%;
            overflow-y: auto;
        }
    }
</style>
